interface AccordionTransitionParams {
  safeToRemoveCb?: (safeToRemove: boolean) => void,
  startTransitionCb?: () => void,
  endTransitionCb?: () => void,
}

export function createAccordionTransition ({ safeToRemoveCb, startTransitionCb, endTransitionCb }: AccordionTransitionParams = {}) {
  return {
    onEnter (el: HTMLElement) {
      if (typeof safeToRemoveCb === 'function') {
        safeToRemoveCb(false);
      }
      window.requestAnimationFrame(() => {
        startTransition(el);
      });
    },
    onAfterEnter (el: HTMLElement) {
      endTransition(el);
    },
    onBeforeLeave (el: HTMLElement) {
      startTransition(el);
    },
    onAfterLeave (el: HTMLElement) {
      if (typeof safeToRemoveCb === 'function') {
        safeToRemoveCb(true);
      }
      window.requestAnimationFrame(() => {
        endTransition(el);
      });
    },
  };

  function startTransition (el: HTMLElement) {
    if (typeof startTransitionCb === 'function') {
      startTransitionCb();
    }
    el.style.height = el.scrollHeight + 'px';
  }

  function endTransition (el: HTMLElement) {
    if (typeof endTransitionCb === 'function') {
      endTransitionCb();
    }
    el.style.height = '';
  }
}
